export const decimalPlaces = (step: number): number => {
  const stringNumber = step.toString();
  const index = stringNumber.indexOf('.');

  if (index < 0) {
    return 0;
  }

  return stringNumber.length - index - 1;
};

export const increaseValue = (value: number, step: number, max?: number) => {
  const newValue = +(value + step).toFixed(decimalPlaces(step));

  if (max !== undefined) {
    return max >= newValue ? newValue : max;
  }

  return newValue;
};

export const decreaseValue = (value: number, step: number, min?: number) => {
  const newValue = +(value - step).toFixed(decimalPlaces(step));

  if (min !== undefined) {
    return min <= newValue ? newValue : min;
  }

  return newValue;
};

export const getNumber = (value: string, min?: number, max?: number): number => {
  const newValue = +value;

  if (!isNaN(newValue)) {
    if (min !== undefined && min > newValue) {
      return min;
    }

    if (max !== undefined && max < newValue) {
      return max;
    }

    return newValue;
  }

  return 0;
};
